import Ch3Architecture from '@/chapters/Ch3Architecture';
import Ch4Solutions from '@/chapters/Ch4Solutions';

export default function SolutionsPage() {
  return (
    <>
      <Ch3Architecture />
      <Ch4Solutions />
    </>
  );
}
